import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { DockAppointments_ModuleContextService } from './DockAppointments.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class DockAppointments_total_appt_not_checked_in_by_date_widget_ComponentContextService {
  private readonly moduleContext: DockAppointments_ModuleContextService;

  constructor(moduleContext: DockAppointments_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'total_appt_not_checked_in_by_date_widget',
      type: ComponentType.widget
    }
  }
}